module.exports = __webpack_public_path__ + "assets/media/citronniers-mobile.031b9ec6.mp4";